import axios from "axios";

const API = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL
      : "http://localhost:5000/api/v1",

  withCredentials: true, 
});

// log every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (process.env.NODE_ENV !== "production") {
    console.log("API REQUEST:", config.url);
    console.log("WITH CREDENTIALS:", config.withCredentials);
    console.log("LOCAL TOKEN:", token);
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// log every response error
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV !== "production") {
      console.log("API ERROR RESPONSE:", error.response?.data);
    }
    return Promise.reject(error);
  }
);

export default API;
